
@if (controller.isLibrary()) {
  <app-library-button></app-library-button>
}

<div class="podcast-page">




  <div class="episode-container">

    <div class="podcast-image">

      <img [src]="getPodcastImageUrl()"/>
    </div>

    <div class="notes">

      <h1>{{episodeTitle}}</h1>
      <h2 class="publish-date">{{publishDate}}</h2>


      @for (element of component.elements; track element) {
        @if (element.type == 'header') {
          <h1 [ngClass]="controller.getClassObject( element, [] )">{{element.value}}</h1>
        }
        @if (element.type == 'p') {
          <p [ngClass]="controller.getClassObject( element, [] )" [innerHTML]="sanitizeHtml(element.value)"></p>
        }
        @if (element.type == 'br') {
          <br />
        }
        @if (element.type == 'a') {
          <p>
            <a target="_blank" [href]="sanitizeUrl(element.properties.href)">{{element.value}}</a></p>
          }
        }

      </div>


    </div>

  </div>

  <div class="player-container">
    <div class="player">
      <iframe scrolling="no" seamless="seamless" style="width: 100%; height: 250px;" [src]="getPodcastUrl()" frameborder="no"></iframe>
    </div>
  </div>

